import React from "react"
import { notification } from "antd"
import { localize } from "../../utils/localize"

const showNotification = (type, title, message) => {
	if (typeof window === "undefined") { return }
	notification[type]({
		message: (title),
		description: <span ref={ref => { if (ref && message) { ref.innerHTML = message } }} />
	})
}

export const showErrorNotification = (code, additional) => {
	const message = code ? code : localize("Sorry, an error has occurred")
	const phrase = additional ? message + additional : message
	showNotification("error", localize("Error"), phrase)
}

export const showWarningNotification = (code, additional) => {
	const message = additional ? code + additional : code
	showNotification("warning", localize("Warning"), message)
}

export const showSuccessNotification = (code, additional) => {
	if (additional) {
		const formatStrings = Array.isArray(additional) ? additional : [additional]
		showNotification("success", localize("Success"), code.format(...formatStrings))
		return
	}
	showNotification("success", localize("Success"), code)
}

export const showInfoNotification = (code) => {
	showNotification("info", localize("Info"), code)
}
